import {
  V2WaterFlowDataLeftPostResponse,
  V2WaterFlowDataRightChartDayPostResponse,
  V2WaterFlowDataRightChartHourPostResponse,
  V2WaterFlowDataRightStatisticPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import dayjs, { Dayjs } from 'dayjs';
export enum TimeActive {
  THIS_MONTH = 'M',
  THIS_WEEK = 'W',
  CUSTOM = 'D',
}
export type RangeValue = [Dayjs, Dayjs];
export interface FlowIdContextProps {
  flowId: number | undefined;
  setFlowId: React.Dispatch<React.SetStateAction<number | undefined>>;
  nodeId: number | undefined;
  setNodeId: React.Dispatch<React.SetStateAction<number | undefined>>;
  nodeTitle: string | undefined;
  setNodeTitle: React.Dispatch<React.SetStateAction<string | undefined>>;
  flowTitle: string | undefined;
  setFlowTitle: React.Dispatch<React.SetStateAction<string | undefined>>;
  flowDate: number | undefined;
  setFlowDate: React.Dispatch<React.SetStateAction<number | undefined>>;
}
export interface TimeRange {
  monitorStartTime: string;
  monitorEndTime: string;
}

export type LeftData = V2WaterFlowDataLeftPostResponse;

// 设备排名项
export type DeviceItem = Exclude<V2WaterFlowDataLeftPostResponse['dataList'], undefined>[number];
export type DeviceRankItem = DeviceItem & {
  rank: number;
};

export type RightStatisticData = V2WaterFlowDataRightStatisticPostResponse;
export type DataList = Exclude<V2WaterFlowDataRightStatisticPostResponse['dataList'], undefined>[number];
export type ChartHourData = V2WaterFlowDataRightChartHourPostResponse;

// 统计卡片
export interface StatisticsCard {
  longFlowDays: number;
  longFlowDaysRatio: number;
  nonLongFlowDays: number;
  nonLongFlowDaysRatio: number;
  longFlowAvgHourly: number;
  nonLongFlowAvgHourly: number;
}

// 图表数据
export interface ChartData {
  time: number;
  totalAmount: number;
  longFlowAmount: number | null;
  nonLongFlowAmount: number | null;
  longFlowProportion?: number;
  nonLongFlowProportion?: number;
  pressure?: number;
  flag?: boolean;
}

// 时间轴数据
export interface TimeAxisData {
  date: string;
  isLongFlow: boolean;
}

export enum DateType {
  DAY = 'D',
  HOUR = 'H',
}

export type DateValue = [Dayjs | null, Dayjs | null];
